module.exports = __webpack_public_path__ + "static/img/wxgzh.b448d6d.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/wxgzh.png
// module id = J5t0
// module chunks = 1